import type { AppAction } from "../app.types"

export interface IMapViewerState {
  pins: Map<string, boolean>
  zoom: Map<string, number>
  panels: Map<MapViewerPanel, boolean>
}

export type MapViewerLastViewed = {
  mapId: string
  title: string
  mapUrl: string
}

export enum MapViewerPanel {
  Drawing = 0,
  DrawSquare = 1,
  DrawCircle = 2,
  DrawPencil = 3,
  DrawText = 4,
  DrawArrow = 5,
  Selection = 6,
  Attachement = 7,
  GoogleMaps = 8
}

export const editPanels: MapViewerPanel[] = [
  MapViewerPanel.Selection,
  MapViewerPanel.DrawSquare,
  MapViewerPanel.DrawCircle,
  MapViewerPanel.DrawPencil,
  MapViewerPanel.DrawText,
  MapViewerPanel.DrawArrow
]

export const actionPanels: MapViewerPanel[] = [
  MapViewerPanel.Drawing,
  MapViewerPanel.Attachement,
  MapViewerPanel.GoogleMaps
]

export type MapViewerActions = MapViewerAction | MapViewerPinAction | MapViewerZoomAction | MapViewerPanelAction
export type MapViewerAction = AppAction<string>
export type MapViewerPinAction = AppAction<boolean> & { mapId: string }
export type MapViewerZoomAction = AppAction<number> & { mapId: string }
export type MapViewerPanelAction = AppAction<
  | {
      panel: MapViewerPanel
      open?: boolean
    }
  | MapViewerPanel
>
